export enum RadioGroupVariant {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
